import MuiBaseModal from "../../common/modal/MuiModal";
import { Stack } from "@mui/material";

import ChargeForm from "../../../forms/charge-form/ChargeForm";
import DeChargeForm from "../../../forms/charge-form/DeChargeForm";

interface IChargeModal {
  onClose: () => void;
  walletId: number;
  increase?: boolean;
  handleReload?: () => void;
}

export default function ChargeModal({
  onClose,
  walletId,
  increase,
  handleReload,
}: Readonly<IChargeModal>) {
  const onFormClose = () => {
    onClose();
    handleReload && handleReload();
  };

  return (
    <MuiBaseModal
      open={!!walletId}
      onClose={onClose}
      title={increase ? "افرایش اعتبار" : "کاهش اعتبار"}
      hasCloseIcon
    >
      <Stack>
        {increase ? (
          <ChargeForm onClose={onFormClose} walletId={walletId} />
        ) : (
          <DeChargeForm onClose={onFormClose} walletId={walletId} />
        )}
      </Stack>
    </MuiBaseModal>
  );
}
